import { render } from "./BuySeats.vue?vue&type=template&id=bba3ddb6&scoped=true"
import script from "./BuySeats.vue?vue&type=script&lang=js"
export * from "./BuySeats.vue?vue&type=script&lang=js"

import "./BuySeats.vue?vue&type=style&index=0&id=bba3ddb6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bba3ddb6"]])

export default __exports__